import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent, watch } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import { loginResource } from '@/services/auth.service'
// import { VueRecaptcha } from 'vue-recaptcha'
import useGlobal from '@/composables/useGlobal'
import useCaptcha from '@utils/useCaptcha'
import { logo_main } from '@/const'

const phoneMask = "+38 (0##) ### ## ##"

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthForm',
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const nextParameterValue = new URLSearchParams(window.location.search).get('next')

const emit = __emit
const load = ref(false)
const { $t } = useGlobal()
const nonFieldErrors = ref("")
const email = ref("")
const password = ref("")
const phone = ref("")
const code = ref("")
const toResetForm = () => {
  emit('changeForm', phone.value)
}

const request = (sendData, control) => {
  useSubmit(send({ ...sendData }, control), control)
}

const send = async (sendData: any, control: any) => {
  try {
      load.value = true
      const preparedData = { ...sendData }
      preparedData.phone = preparedData.phone.replace(/\D/g, '')
      const { data } = await loginResource.execute({}, {
        ...preparedData,
      })
      window.location.href = nextParameterValue || data.item.redirectInk || '/cabinet'
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}



const __returned__ = { nextParameterValue, emit, load, $t, nonFieldErrors, email, password, phone, code, phoneMask, toResetForm, request, send, ref, defineAsyncComponent, watch, get useSubmit() { return useSubmit }, get loginResource() { return loginResource }, get useGlobal() { return useGlobal }, get useCaptcha() { return useCaptcha }, get logo_main() { return logo_main } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})